import React, {useCallback} from 'react'
import {useState, useEffect} from 'react'
import {useFormik} from 'formik'

import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import MuiPhoneNumber from 'material-ui-phone-number'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {
  MDBCard,
  MDBCardBody,
  MDBCol,
  MDBInput,
  MDBRow,
  MDBTextArea,
  MDBCardHeader,
  MDBTypography,
} from 'mdb-react-ui-kit'
import {
  Get_Property_Type,
  Get_Carpet_Unit,
  Get_Country,
  Get_Province,
  Create_Property,
} from './Property_Api'
import {useLocation} from 'react-router-dom'
import AddPropertyDocs from './Add_PropertyDocs'
import AddIcon from '@mui/icons-material/Add'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import {useDropzone} from 'react-dropzone'
import {RMIUploader} from 'react-multiple-image-uploader'
import ImageUploading from 'react-images-uploading'
import {makeStyles} from '@material-ui/core/styles'
import Swal from 'sweetalert2/src/sweetalert2.js'
import {useNavigate} from 'react-router-dom'
import {Create_Property_Admin} from '../superAdmin/SAdminSingleProperty/SuperAdminSingle_Api'
import './property_style.css'

const initialValues = {
  Propertytypee: '',
  Propertytitle: '',
  CarpetArea: '',
  unit: '',
  address1: '',
  address2: '',
  country: '',
  province: '',
  pin: '',
  city: '',
  rent: '',
  accType: '',
  ownername: '',
  owner_email_id: '',
  owner_contact_number: '',
  // sub_div:'',
  // property:'',
  // numRoom:'',
  // residential: '',
  // commercial:'',
  // property_unit_name:'',
  // property_unit_description:'',
  // property_unit_max_tenants:'',
  // property_unit_rent:''

  // agent_address1:'',
  // agent_address2:'',
  // agent_country:'',
  // agent_province:'',
  // agent_pin:'',
  // agent_city:''
}

interface FileMeta {
  name: string
  size: number
  type: string
}

interface UploadedFile {
  meta: {
    name: string
    size: number
    type: string
  }
  remove: () => void
}

interface propertyType {
  property_type_id: number
  property_type_uuid: string
  property_type_name: string
}

interface carpetUnit {
  carpet_area_unit_uuid: string
  carpet_area_unit_id: number
  carpet_area_unit_name: string
}

interface country {
  country_id: number
  country_name: string
}

interface provincee {
  province_name: string
  province_id: number
}
interface Props {
  onBackButtonClick: () => void;
}

const registrationSchema = Yup.object().shape({
  Propertytypee: Yup.string().required('Property Type is required'),
  Propertytitle: Yup.string()
    .matches(/^[A-Za-z0-9 ]*$/, 'Only alphanumeric characters and spaces are allowed')
    .min(3, 'Minimum 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('Property Title Required'),

  CarpetArea: Yup.number()
    .typeError('CarpetArea must be a number')
    .positive('CarpetArea must be a positive number')
    .integer('CarpetArea must be an integer')
    .min(1, 'CarpetArea must be at least 1')
    .max(99999, 'CarpetArea cannot be more than 99999')
    .required('CarpetArea is required'),

  unit: Yup.string().required('Unit is required'),
  address1: Yup.string()

    .min(3, 'Minimum 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('Address is required'),
  accType: Yup.string().required(),
  address2: Yup.string()
    .matches(/^[A-Za-z0-9, ]*$/, 'Only alphanumeric characters, spaces, and commas are allowed')
    .min(3, 'Minimum 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .optional(),
  pin: Yup.number()
    .typeError('Pincode must be a number')
    .positive('Pincode must be a positive number')
    .integer('Pincode must be an integer')
    .min(100000, 'Pincode must be at least 6 digits')
    .max(999999, 'Pincode cannot be more than 6 digits')
    .required('Pincode is required'),
  province: Yup.number().required('Province is required'),
  city: Yup.string()
    .matches(/^[A-Za-z ]*$/, 'Only alphabets and spaces are allowed')
    .min(3, 'Minimum 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('City is required'),

  country: Yup.number().required('Country is required'),
  rent: Yup.number()
    .typeError('Rent must be a number')
    .positive('Rent must be a positive number')
    .integer('Rent must be an integer')
    .required('Rent is required'),

  ownername: Yup.string().min(3, 'Minimum 3 symbols').max(50, 'Maximum 50 symbols').optional(),
  owner_email_id: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .optional(),
  owner_contact_number: Yup.string().optional(),

  // sub_div:Yup.bool().optional(),
  // property:  Yup.string().when('sub_div', {
  //     is: true,
  //     then: Yup.string().required('Required')
  //   }),

  // residential: Yup.any().when('sub_div', {
  //   is: true,
  //   then: Yup.string().optional()
  // }),
  // commercial: Yup.string().when('sub_div', {
  //   is: true,

  //     then: Yup.string().optional(),
  //   }),
  // numRoom:Yup.string().when('sub_div', {
  //   is: true,
  //   then: Yup.string().required('Required')
  // }),

  // property_unit_name:Yup.string().when('sub_div', {
  //   is: true,
  //   then: Yup.string().required('Required')
  // }),
  // property_unit_description:Yup.string().when('sub_div', {
  //   is: true,
  //   then: Yup.string().required('Required')
  // }),

  // property_unit_max_tenants:Yup.number().when('sub_div', {
  //   is: true,
  //   then: Yup.number().required('Required')
  // }),
  // property_unit_rent:Yup.number().when('sub_div', {
  //   is: true,
  //   then: Yup.number().required('Required')
  // }),

  // agent_address1:Yup.string().
  // min(3, 'Minimum 3 symbols').
  // max(50, 'Maximum 50 symbols')
  // .optional(),
  // agent_address2:Yup.string().
  // min(3, 'Minimum 3 symbols').
  // max(50, 'Maximum 50 symbols')
  // .optional(),
  // agent_country:Yup.number().optional(),
  // agent_province:Yup.number().optional(),
  // agent_pin:Yup.number().min(6, 'Minimum 6 number required').optional(),
  // agent_city:Yup.string().optional(),
})

const Add_NewProperty: React.FC<Props> = (props: Props) => {
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [visible, setVisible] = useState(false)
  const [check, setCheck] = useState(false)
  const location = useLocation()
  const [showAgent, setShowAgent] = useState(false)
  const [Propertystatus, setPropertystatus] = useState(1)
  const [propertyType, setPropertyType] = useState<propertyType[]>([])
  const [category,setcategory] =useState<string | undefined>()
  const [carpetUnit, setCarpetUnit] = useState<carpetUnit[]>([])
  const [getCountry, setGetCountry] = useState<country[]>([])
  const [getprovince, setGetProvince] = useState<provincee[]>([])
  const [getagentprovince, setGetAgentProvince] = useState<provincee[]>([])
  const [selectedCountry, setSelectedCountry] = useState<number | 0>()
  const [isAgent, setisAgent] = useState(false)
  const [agentCountry, setagentCountry] = useState<number | 0>()
  const [next, setNext] = useState(false)
  const navigate = useNavigate()
  const intl = useIntl()
  const [ischeck, setisCheck] = useState(false)
  const [text, setText] = useState<string | null>(null)
  const [numTextboxes, setNumTextboxes] = useState(1)
  const [resProperty, setresProperty] = useState(false)
  const [comProperty, setcomProperty] = useState(false)
  const [numRooms, setNumRooms] = useState(0)
  const [roomDetails, setRoomDetails] = useState<
    {
      property_unit_name: string
      property_unit_description: string
      property_unit_max_tenants: number
      property_unit_rent: number
    }[]
  >([])
  const {account_uuid, email_id, contact_number, accouont_holder_name} = location.state || ''

  let userType = localStorage.getItem('user_type') || ''

  // receives array of files that are done uploading when submit button is clicked
  const handleSubmit = (files: UploadedFile[], allFiles: UploadedFile[]) => {
    console.log(files.map((f) => f.meta))
    allFiles.forEach((f) => f.remove())
    setOpen(false)
  }

  //function to set country
  const handleSelectCountry = (country: number) => {
    try {
      setSelectedCountry(country)
      getProvinceeee(country)
    } catch (error) {
      console.log(error)
    }
  }

  //function to set agent country



 

  const agenthandleSelectCountry = (country: number) => {
    try {
      get_agent_Province(country)
    } catch (error) {
      console.log(error)
    }
  }
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
    
        console.log('values', values)
        const selectedCountryValue = selectedCountry !== undefined ? selectedCountry : 1
        const agentselectedCountryValue = agentCountry !== undefined ? agentCountry : 1
        const provinceValue = Number(values.province)
        //const agent_province = Number( values.agent_province)
        const pin_zip = Number(values.pin)
        const rent = Number(values.rent)
        //const agent_pin = Number( values.agent_pin )
        const isAgent = values.accType === 'Agent' ? true : false
    
        console.log('array', roomDetails)
        let data = {
          property_type_uuid: values.Propertytypee,
          property_title: values.Propertytitle,
          carpet_area: parseInt(values.CarpetArea, 10),
          carpet_area_unit_uuid: values.unit,
          address_1: values.address1,
          address_2: values.address2,
          country_id: selectedCountryValue,
          province_id: provinceValue,
          city: values.city,
          pin_zip: pin_zip,
          current_rent: rent,
          isAgent: isAgent,
          owner_name: values.ownername === '' ? ' ' : values.ownername,
          owner_email_id: values.owner_email_id === '' ? ' ' : values.owner_email_id,
          owner_contact_number:
            values.owner_contact_number === ' ' ? ' ' : values.owner_contact_number,
          sub_unit_available: check,
          property_usage_type: Propertystatus,
          unitdetails: roomDetails,
    
          // agent_address_1     :values.agent_address1,
          // agent_address_2     :values.agent_address2,
          // agent_country_id    : agentselectedCountryValue,
          // agent_province_id   : agent_province,
          // agent_city          :values.agent_city ,
          // agent_pin_zip       :agent_pin
        }
        console.log('data ', data)
    
        if (userType === 'Super Admin') {
          const {data: resp = {}} = await Create_Property_Admin(
            values.Propertytypee,
            values.Propertytitle,
            parseInt(values.CarpetArea, 10),
            values.unit,
            values.address1,
            values.address2,
            selectedCountryValue,
            provinceValue,
            values.city,
            pin_zip,
            rent,
            isAgent,
            accouont_holder_name,
            email_id,
            contact_number
          )
          //agentselectedCountryValue,
          console.log('result ', resp.code)
          if (resp.code == 200) {
            setNext(true)
    
            localStorage.setItem('property_id', resp.data.property_id)
          } else if (resp.code == 500) {
            Swal.fire({
              icon: 'error',
              title: resp.msg_details,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload()
              }
            })
          } else {
            console.log('>>>>', resp.msg_details)
            Swal.fire({
              icon: 'error',
              title: resp.msg_details,
            }).then((result) => {
              if (result.isConfirmed) {
                setLoading(false)
              }
            })
          }
        } else {
          const {data: resp = {}} = await Create_Property(
            values.Propertytypee,
            values.Propertytitle,
            parseInt(values.CarpetArea, 10),
            values.unit,
            values.address1,
            values.address2,
            selectedCountryValue,
            provinceValue,
            values.city,
            pin_zip,
            rent,
            isAgent,
            values.ownername,
            values.owner_email_id,
            values.owner_contact_number,
            check,
            Propertystatus,
            roomDetails
          )
          //agentselectedCountryValue,
    
          if (resp.code == 200) {
            setNext(true)
    
            localStorage.setItem('property_id', resp.data.property_id)
          } else {
            Swal.fire({
              icon: 'error',
              title: resp.msg_details,
            }).then((result) => {
              if (result.isConfirmed) {
                navigate('/property')
              }
            })
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
  })

  const handleClick = () => {
    // const customState = { someData: 'propertyHome' };
    // const url =('/property')
    //window.history.pushState({}, '', url);
    // window.history.back()
  
  }

  function show() {
    setOpen(!open)
  }

  function showDoc() {
    setVisible(!visible)
  }

  function agentdetails() {
    if (userType === 'Super Admin') {
      setShowAgent(false)
    } else {
      setShowAgent(!showAgent)
    }
  }

  function ownerdetails() {
    setShowAgent(false)
    // setShowOwner(!showOwner)
  }

  // functions to get data on form

  async function getPropertyType() {
    const {data: response} = await Get_Property_Type()
    console.log('res', response.data)
    let responseData = response.data as propertyType[]

    // responseData.map((item) =>{
    //   console.log(item.property_type_name)
    // })
    setPropertyType(responseData)
  }

  // function  to get carpet area on form

  async function getcarpetunit() {
    const {data: res} = await Get_Carpet_Unit()
    console.log('res', res)
    let responseData = res.data as carpetUnit[]
    setCarpetUnit(responseData)
  }

  // function  to get country
  async function getCountryy() {
    const {data: res} = await Get_Country()
    console.log(res.data)
    let responseData = res.data as country[]
    setGetCountry(responseData)
  }

  // function to get providence
  async function getProvinceeee(country: number) {
    const {data: res} = await Get_Province(country)
    let responseData = res.data as provincee[]
    setGetProvince(responseData)
  }

  //function to get agent province
  async function get_agent_Province(country: number) {
    const {data: res} = await Get_Province(country)
    let responseData = res.data as provincee[]
    setGetAgentProvince(responseData)
  }

  //if it checked

  function isChecked(event: React.ChangeEvent<HTMLInputElement>) {
  
    if (category === 'residential') {
       
    //setCheck(true)

    setCheck(event.target.checked)

   setisCheck(!ischeck)
      setPropertystatus(1)
      setresProperty(true)
      setcomProperty(false)
      setNumRooms(0)
      setRoomDetails([])
      formik.setFieldValue('sub_div', !check)
    } else if (category === 'commercial') {
       
    // setCheck(true)

    setCheck(event.target.checked)

   setisCheck(!ischeck)
      setPropertystatus(2)
      setcomProperty(true)
      setresProperty(false)
      setNumRooms(0)
      setRoomDetails([])
      formik.setFieldValue('sub_div', !check)
    }

    
  }

  function handlePropertyChange(event: any) {
    console.log("event",event.target.value)
    setcategory(event.target.value)
    setisCheck(false)
    setNumRooms(0)
    setRoomDetails([])
    setCheck(false)
   }

  function handleNumRoomsChange(event: any) {
    const numRooms = parseInt(event.target.value)
    setNumRooms(numRooms)
    // Create an empty array with `numRooms` number of elements
    setRoomDetails(
      Array.from({length: numRooms}, () => ({
        property_unit_name: '',
        property_unit_description: '',
        property_unit_max_tenants: 0,
        property_unit_rent: 0,
      }))
    )
  }
  function handleRoomDetailChange(
    event: any,
    index: number,
    field:
      | 'property_unit_name'
      | 'property_unit_description'
      | 'property_unit_max_tenants'
      | 'property_unit_rent'
  ) {
    const value = event.target.value
    setRoomDetails((prevDetails) => {
      const newDetails: {
        property_unit_name: string
        property_unit_description: string
        property_unit_max_tenants: number
        property_unit_rent: number
      }[] = prevDetails.map((detail, i) => {
        if (i !== index) return detail
        return {...detail, [field]: field === 'property_unit_max_tenants' ? parseInt(value) : value}
      })
      console.log(newDetails)
      return newDetails
    })
  }

  // function to add new line

  const handleAddNewLine = (e: any) => {
    e.preventDefault()
    console.log('fshfhgsfyg')
    setNumTextboxes(numTextboxes + 1)
  }

  const SubmitOptions = (e: any) => {
    e.preventDefault()
    console.log('textbox value ', text)
  }

  const handleKeyPress = (event:any) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };   

  useEffect(() => {
    getPropertyType()
    getcarpetunit()
    getCountryy()
  }, [])
  return next ? (
    <AddPropertyDocs />
  ) : (

    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_signin_form'
      onSubmit={formik.handleSubmit}
    >
      <>
      <button className='btn btn-light-primary'   onClick={props.onBackButtonClick}>
      <img style={{height :'20px'}} src="https://img.icons8.com/fluency/96/000000/back.png"/>
      {/* <img  style={{height :'20px',backgroundColor:'white'}} src='"https://img.icons8.com/fluency/48/000000/back.png' alt='back'/> */}
      </button></>
      {localStorage.getItem('userType') === 'Super Admin' ? (
        <PageTitle breadcrumbs={[]}>
          {intl.formatMessage({id: `${accouont_holder_name}`})}
        </PageTitle>
      ) : (
        ''
      )}
      <MDBRow>
        <MDBCol className='mb-4'>
          <MDBCard className='mb-4'>
            <MDBCardHeader className='py-4'>
              <MDBTypography tag='h1' className='mb-4'>
                <div style={{marginTop: '40px', width: '100%'}}>Add Property</div>
              </MDBTypography>
            </MDBCardHeader>
            <MDBCardBody>
              {formik.status && (
                <div className='mb-lg-15 alert alert-danger'>
                  <div className='alert-text font-weight-bold'>{formik.status}</div>
                </div>
              )}
              <MDBRow className='mb-4'>
                <div className='error'> {} </div>
              </MDBRow>
              <MDBRow className='fv-row mb-3'>
                <MDBCol className='form-label fw-bolder text-dark fs-6'>
                  <div>
                    <label className='form-label fw-bolder text-dark fs-6'>Property Type *</label>

                    <select
                      aria-label='PropertyType'
                      autoComplete='off'
                      {...formik.getFieldProps('Propertytypee')}
                      className={clsx(
                        'form-control bg-transparent form-select form-select-solid',
                        {
                          'is-invalid': formik.touched.Propertytypee && formik.errors.Propertytypee,
                        },
                        {
                          'is-valid': formik.touched.Propertytypee && !formik.errors.Propertytitle,
                        }
                      )}
                    >
                     
                      <option>Select Property Type *</option>
                      {propertyType.map((item) => (
                        <option key={item.property_type_uuid} value={item.property_type_uuid}>
                          {item.property_type_name}
                        </option>
                      ))}
                    </select>
                    {formik.touched.Propertytitle && formik.errors.Propertytitle && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.Propertytitle}</span>
                          </div>
                        </div>
                      )}
                  </div>
                </MDBCol>
                <MDBCol className='form-label fw-bolder text-dark fs-6'>
                  <label className='form-label fw-bolder text-dark fs-6'>Property Title *</label>
                  <input
                    type='text'
                    onKeyPress={handleKeyPress}
                    placeholder='Property title'
                    autoComplete='off'
                    {...formik.getFieldProps('Propertytitle')}
                    className={clsx(
                      'form-control bg-transparent',
                      {
                        'is-invalid': formik.touched.Propertytitle && formik.errors.Propertytitle,
                      },
                      {
                        'is-valid': formik.touched.Propertytitle && !formik.errors.Propertytitle,
                      }
                    )}
                  />
                  {formik.touched.Propertytitle && formik.errors.Propertytitle && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.Propertytitle}</span>
                      </div>
                    </div>
                  )}
                </MDBCol>
              </MDBRow>

              <MDBRow className='fv-row mb-3'>
                <MDBCol className='form-label fw-bolder text-dark fs-6'>
                  <label className='form-label fw-bolder text-dark fs-6'>Carpet Area *</label>{' '}
                  <input
                    type='text'
                    data-bs-toggle='tooltip'
                    onKeyPress={handleKeyPress}
                    data-bs-placement='top'
                    title='e'
                    placeholder='Carpet Area'
                    autoComplete='off'
                    {...formik.getFieldProps('CarpetArea')}
                    className={clsx(
                      'form-control bg-transparent',
                      {
                        'is-invalid': formik.touched.CarpetArea && formik.errors.CarpetArea,
                      },
                      {
                        'is-valid': formik.touched.CarpetArea && !formik.errors.CarpetArea,
                      }
                    )}
                  />
                  {formik.touched.CarpetArea && formik.errors.CarpetArea && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.CarpetArea}</span>
                      </div>
                    </div>
                  )}
                </MDBCol>

                <MDBCol className='form-label fw-bolder text-dark fs-6'>
                  <div>
                    <label className='form-label fw-bolder text-dark fs-6'>Unit *</label>
                    <select
                      style={{width: '200px'}}
                      aria-label='Unit'
                      autoComplete='off'
                      {...formik.getFieldProps('unit')}
                      className={clsx(
                        'form-control bg-transparent form-select form-select-solid',
                        {
                          'is-invalid': formik.touched.unit && formik.errors.unit,
                        },
                        {
                          'is-valid': formik.touched.unit && !formik.errors.unit,
                        }
                      )}
                    >
                     
                      <option>Select Unit *</option>
                      {carpetUnit.map((item) => (
                        <option key={item.carpet_area_unit_uuid} value={item.carpet_area_unit_uuid}>
                          {item.carpet_area_unit_name}
                        </option>
                      ))}
                    </select>
                    {formik.touched.unit && formik.errors.unit && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.unit}</span>
                          </div>
                        </div>
                      )}
                  </div>
                </MDBCol>
              </MDBRow>

              <MDBRow className='fv-row mb-3'>
                <MDBCol className='form-label fw-bolder text-dark fs-6'>
                  <div className='form-label fw-bolder text-dark fs-6'>
                    <label className='form-label fw-bolder text-dark fs-6'>Address 1 *</label>
                    <MDBTextArea
                      label=''
                      rows={4}
                      autoComplete='off'
                      {...formik.getFieldProps('address1')}
                      className={clsx(
                        'form-control bg-transparent',
                        {
                          'is-invalid': formik.touched.address1 && formik.errors.address1,
                        },
                        {
                          'is-valid': formik.touched.address1 && !formik.errors.address1,
                        }
                      )}
                    />
                    {formik.touched.address1 && formik.errors.address1 && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.address1}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </MDBCol>
                <MDBCol className='form-label fw-bolder text-dark fs-6'>
                  <div className='form-label fw-bolder text-dark fs-6'>
                    <label className='form-label fw-bolder text-dark fs-6'>Address 2</label>
                    <MDBTextArea
                      label=''
                      rows={4}
                      autoComplete='off'
                      {...formik.getFieldProps('address2')}
                      className={clsx(
                        'form-control bg-transparent',
                      {
                          'is-invalid': formik.touched.address2 && formik.errors.address2,
                        },  
                        // {
                        //   'is-valid': formik.touched.address2 && !formik.errors.address2,
                        // }
                      )}
                    />
                    {formik.touched.address2 && formik.errors.address2 && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.address2}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </MDBCol>
              </MDBRow>

              <MDBRow className='fv-row mb-3'>
              <MDBCol className='form-label fw-bolder text-dark fs-6'>
  <label className='form-label fw-bolder text-dark fs-6'>Country *</label>
  <select
    aria-label='Country'
    onChange={(e) => {
      handleSelectCountry(parseInt((e.target as HTMLSelectElement).value, 10));
      formik.setFieldValue('country', parseInt((e.target as HTMLSelectElement).value, 10));
      formik.setFieldTouched('country', true);
    }}
    onBlur={() => formik.setFieldTouched('country', true)}
    value={formik.values.country}
    className={clsx(
      'form-control bg-transparent form-select form-select-solid',
      {
        'is-invalid': formik.touched.country && formik.errors.country,
      },
      {
        'is-valid': formik.touched.country && !formik.errors.country,
      }
    )}
  >
    <option value=''>Select Country</option>
    {getCountry.map((item) => (
      <option key={item.country_id} value={item.country_id}>
        {item.country_name}
      </option>
    ))}
  </select>
  {formik.touched.country && formik.errors.country && (
    <div className='fv-plugins-message-container'>
      <div className='fv-help-block'>
        <span role='alert'>{formik.errors.country}</span>
      </div>
    </div>
  )}
</MDBCol>

                <MDBCol className='form-label fw-bolder text-dark fs-6'>
                  <div>
                    <label className='form-label fw-bolder text-dark fs-6'>Province/State *</label>
                    <select
                      autoComplete='off'
                      {...formik.getFieldProps('province')}
                      className={clsx(
                        'form-control bg-transparent form-select form-select-solid',
                        {
                          'is-invalid': formik.touched.province && formik.errors.province,
                        },
                        {
                          'is-valid': formik.touched.province && !formik.errors.province,
                        }
                      )}
                    >
                     
                      <option>Select Province/State</option>
                      {getprovince.map((item) => (
                        <option key={item.province_id} value={item.province_id}>
                          {item.province_name}
                        </option>
                      ))}
                    </select>
                    {formik.touched.province && formik.errors.province && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.province}</span>
                          </div>
                        </div>
                      )}
                  </div>
                </MDBCol>
                <MDBCol className='form-label fw-bolder text-dark fs-6'>
                  <div className='form-label fw-bolder text-dark fs-6'>
                    <label className='form-label fw-bolder text-dark fs-6'>City *</label>
                    <input
                      type='text'
                      onKeyPress={handleKeyPress}
                      autoComplete='off'
                      {...formik.getFieldProps('city')}
                      className={clsx(
                        'form-control bg-transparent',
                        {
                          'is-invalid': formik.touched.city && formik.errors.city,
                        },
                        {
                          'is-valid': formik.touched.city && !formik.errors.city,
                        }
                      )}
                    />
                    {formik.touched.city && formik.errors.city && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.city}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </MDBCol>
                <MDBCol className='form-label fw-bolder text-dark fs-6'>
                  <div className='form-label fw-bolder text-dark fs-6'>
                    <label className='form-label fw-bolder text-dark fs-6'>Pin/Zip *</label>
                    <input
                      type='text'
                      onKeyPress={handleKeyPress}
                      autoComplete='off'
                      {...formik.getFieldProps('pin')}
                      className={clsx(
                        'form-control bg-transparent',
                        {
                          'is-invalid': formik.touched.pin && formik.errors.pin,
                        },
                        {
                          'is-valid': formik.touched.pin && !formik.errors.pin,
                        }
                      )}
                    />
                    {formik.touched.pin && formik.errors.pin && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.pin}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </MDBCol>
                
              </MDBRow>

              <MDBRow className='fv-row mb-1'></MDBRow>

              <MDBRow className='fv-row mb-3'>
                <MDBCol className='form-label fw-bolder text-dark fs-6'>
                  <div className='form-label fw-bolder text-dark fs-6'>
                    <label className='form-label fw-bolder text-dark fs-6'>
                      Total Expected Rent*
                    </label>
                    <input
                      type='text'
                      autoComplete='off'
                      style={{width: '49%'}}
                      {...formik.getFieldProps('rent')}
                      className={clsx(
                        'form-control bg-transparent',
                        {
                          'is-invalid': formik.touched.rent && formik.errors.rent,
                        },
                        {
                          'is-valid': formik.touched.rent && !formik.errors.rent,
                        }
                      )}
                    />
                    {formik.touched.rent && formik.errors.rent && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.rent}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <div className='mb-10'>
                  <label className='form-label fw-bolder text-dark fs-6'> Are You *</label>
                  <div className='form-check form-check-custom form-check-solid form-check-lg'>
                    <input
                      {...formik.getFieldProps('accType')}
                      //  value="accTypeOwner"
                      //  checked={formik.values.accType === "accTypeOwner"}
                      //  onChange={(e) => {
                      //    formik.setFieldValue('accTypeOwner', e.target.value);
                      //  }}
                      className='form-check-input'
                      type='radio'
                      value='Owner'
                      name='accType'
                      onClick={ownerdetails}
                    />
                    <label className='form-check-label' htmlFor='flexCheckboxSm'>
                      An Owner
                    </label>
                    <input
                      style={{marginLeft: '10px'}}
                      {...formik.getFieldProps('accType')}
                      // value="accTypeAgent"
                      // checked={formik.values.accType === "accTypeAgent"}
                      // onChange={(e) => {
                      //   formik.setFieldValue('accTypeAgent', e.target.value);
                      // }}
                      value='Agent'
                      className='form-check-input'
                      type='radio'
                      id='accTypeAgent'
                      name='accType'
                      onClick={agentdetails}
                    />
                    <label className='form-check-label' htmlFor='flexCheckboxSm'>
                      An Agent
                    </label>
                  </div>
               
                </div>
              </MDBRow>

              <MDBRow>
                {showAgent ? (
                  <>
                    <MDBRow className='fv-row mb-3'>
                      <MDBCol className='form-label fw-bolder text-dark fs-6'>
                        <label className='form-label fw-bolder text-dark fs-6'>Owner Name</label>
                        <input
                          type='text'
                          placeholder='Owner Name'
                          autoComplete='off'
                          {...formik.getFieldProps('ownername')}
                          className={clsx(
                            'form-control bg-transparent',
                            {
                              'is-invalid': formik.touched.ownername && formik.errors.ownername,
                            },
                            {
                              'is-valid': formik.touched.ownername && !formik.errors.ownername,
                            }
                          )}
                        />
                        {formik.touched.ownername && formik.errors.ownername && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.ownername}</span>
                            </div>
                          </div>
                        )}
                      </MDBCol>
                      <MDBCol className='form-label fw-bolder text-dark fs-6'>
                        <label className='form-label fw-bolder text-dark fs-6'>Owner Email</label>
                        <input
                          type='text'
                          placeholder='Owner Email'
                          autoComplete='off'
                          {...formik.getFieldProps('owner_email_id')}
                          className={clsx(
                            'form-control bg-transparent',
                            {
                              'is-invalid':
                                formik.touched.owner_email_id && formik.errors.owner_email_id,
                            },
                            {
                              'is-valid':
                                formik.touched.owner_email_id && !formik.errors.owner_email_id,
                            }
                          )}
                        />
                        {formik.touched.owner_email_id && formik.errors.owner_email_id && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.owner_email_id}</span>
                            </div>
                          </div>
                        )}
                      </MDBCol>
                    </MDBRow>

                    <MDBRow className='fv-row mb-3'>
                      <MDBCol className='form-label fw-bolder text-dark fs-6'>
                        <div className='fv-row mb-8'>
                          <MuiPhoneNumber
                            defaultCountry={'in'}
                            {...formik.getFieldProps('owner_contact_number')}
                            onChange={(value) =>
                              formik.setFieldValue('owner_contact_number', value)
                            }
                            className={clsx(
                              'form-control bg-transparent',
                              {
                                'is-invalid':
                                  formik.touched.owner_contact_number &&
                                  formik.errors.owner_contact_number,
                              },
                              {
                                'is-valid':
                                  formik.touched.owner_contact_number &&
                                  !formik.errors.owner_contact_number,
                              }
                            )}
                          />

                          {formik.touched.owner_contact_number &&
                            formik.errors.owner_contact_number && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                  <span role='alert'>{formik.errors.owner_contact_number}</span>
                                </div>
                              </div>
                            )}
                        </div>
                      </MDBCol>
                      <MDBCol className='form-label fw-bolder text-dark fs-6'></MDBCol>
                    </MDBRow>
                  </>
                ) : (
                  ''
                )}
              </MDBRow>


              <MDBRow className='fv-row mb-3'>
                    <div role='group' aria-labelledby='my-radio-group'>
                      <MDBCol className='form-label fw-bolder text-dark fs-6'>
                        {/* <div className="mb-10">
  <div className="form-check form-check-custom form-check-solid form-check-sm"> */}
 <label className='form-label fw-bolder text-dark fs-6'>
 Category *
                    </label>
                    <div className='form-check'>
                        <input
                          className='form-check-input'
                          autoComplete='off'
                          id='flexCheckboxSm'
                          {...formik.getFieldProps('residential')}
                          type='radio'
                          value='residential'
                          name='property'
                          // id="residential"
                          onChange={handlePropertyChange}
                        />
                        <label
                          className='form-check-label'
                          style={{marginLeft: '10px'}}
                          htmlFor='residential'
                        >
                          Residential Property
                        </label>
                        </div>
                      </MDBCol>

                      <MDBCol className='form-label fw-bolder text-dark fs-6'>
                        <input
                          className='form-check-input'
                          autoComplete='off'
                          id='flexCheckboxSm'
                          {...formik.getFieldProps('commercial')}
                          type='radio'
                          value='commercial'
                          name='property'
                          onChange={handlePropertyChange}
                        />
                        <label
                          className='form-check-label'
                          style={{marginLeft: '10px'}}
                          htmlFor='commercial'
                        >
                          Commercial Property
                        </label>
                      </MDBCol>
                    </div>
                  </MDBRow>

              <MDBRow>
                <div className='mb-10'>
                  <div className='form-check form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      checked={check}
                      onChange={isChecked}
                    />
                    <label className='form-check-label'>Do property have subdivisions?</label>
                  </div>
                </div>
              </MDBRow>

              {ischeck ? (
                <>
                
                  {/* </div>
</div> */}

                  {/* {[...Array(numTextboxes)].map((_, index) => (
        <MDBRow>
      <input key={index} type="text"  onChange={(event) => setText(event.target.value)}  className="form-control form-control-white"  style={{width:'49%'}} />
      <button type='submit'   style={{width:'10%',marginTop:'-4%',marginLeft:'50%',marginBottom:'5px'}} role="button"  className='btn btn-light-primary' onClick={SubmitOptions} >Submit</button>
     </MDBRow> ))}
      <button  className='btn btn-light-primary' style={{width:'10%',marginTop:'-6.5%',marginLeft:'62%',marginBottom:'5px'}} onClick={handleAddNewLine}>Add More</button> */}

                  {/* <input
    type="text"
    style={{width:'50%'}}
    className="form-control form-control-white"
    placeholder="Name"
    value={text}
    onChange={(event) => setText(event.target.value)}
  />
  <div style={{width:'10%',marginTop:'-4%',marginLeft:'50%',marginBottom:'5px'}} >
      <button type='submit' role="button"  className='btn btn-light-primary' onClick={handleAddNewLine}>Add</button>
      <AddIcon />
      </div> */}
                </>
              ) : (
                ''
              )}

 {ischeck ? (
  <>
              {resProperty ? (
                <>
                  <label className='form-label fw-bolder text-dark fs-6'>
                    Enter the number of rooms:
                  </label>

                  <input
                    type='text'
                    autoComplete='off'
                    className='form-control bg-transparent'
                    style={{width: '10%', marginBottom: '10px'}}
                    // value={numRooms}

                    // {...formik.getFieldProps('numRoom')}
                    // className={clsx(
                    //   'form-control bg-transparent ',
                    //   {
                    //     'is-invalid': formik.touched.numRoom && formik.errors.numRoom,
                    //   },
                    //   {
                    //     'is-valid': formik.touched.numRoom && !formik.errors.numRoom,
                    //   }
                    // )}

                    onChange={handleNumRoomsChange}
                  />
                 

                  {/* {formik.touched.numRoom &&
                            formik.errors.numRoom && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                  <span role='alert'>{formik.errors.numRoom}</span>
                                </div>
                              </div>
                            )} */}

                  {roomDetails.map((detail, index) => (
                    // <MDBRow>
                    // <div key={index} >
                    //   <h2>Room {index+1}</h2>
                    //   <MDBCol style={{display:'flex',justifyContent:'space-around'}} >
                    //   <label className='form-label fw-bolder text-dark fs-6'>Name:</label>

                    //   <input className ="form-control bg-transparent "  style ={{width:'25%'}}type="text" value={detail.unitName} onChange={event => handleRoomDetailChange(event, index, 'unitName')} required />

                    //   <label className='form-label fw-bolder text-dark fs-6'>Description:</label>
                    //   <input type="text" className ="form-control bg-transparent" style ={{width:'25%'}}value={detail.roomDesc} onChange={event => handleRoomDetailChange(event, index, 'roomDesc')} required />

                    //   <label className='form-label fw-bolder text-dark fs-6'>No of tenants:</label>
                    //   <input type="number" className ="form-control bg-transparent" style ={{width:'30%'}} value={detail.numTenants} onChange={event => handleRoomDetailChange(event, index, 'numTenants')} required />
                    //   </MDBCol>
                    //    </div>
                    //   </MDBRow>

                    <MDBRow>
                      <div key={index} style={{marginBottom: '20px'}}>
                        <h2 className='text-primary '>Room {index + 1}</h2>
                        <MDBCol style={{display: 'flex', justifyContent: 'space-around'}}>
                          <div className='form-label fw-bolder text-dark fs-6'>
                            <label className='form-label fw-bolder text-dark fs-6'> Name</label>
                            <input
                              type='text'
                              autoComplete='off'
                              key={index}
                              className='form-control bg-transparent'
                              value={roomDetails[index]?.property_unit_name || ''}
                              onChange={(event) =>
                                handleRoomDetailChange(event, index, 'property_unit_name')
                              }
                            />
                          </div>

                          <div className='form-label fw-bolder text-dark fs-6'>
                            <label className='form-label fw-bolder text-dark fs-6'>
                              {' '}
                              Description
                            </label>
                            <textarea
                              autoComplete='off'
                              className='form-control bg-transparent'
                              key={index}
                              value={roomDetails[index]?.property_unit_description || ''}
                              onChange={(event) =>
                                handleRoomDetailChange(event, index, 'property_unit_description')
                              }
                            />
                          </div>

                          <div className='form-label fw-bolder text-dark fs-6'>
                            <label className='form-label fw-bolder text-dark fs-6'>
                              No of tenants
                            </label>
                            <input
                              type='number'
                              autoComplete='off'
                              className='form-control bg-transparent'
                              onChange={(event) =>
                                handleRoomDetailChange(event, index, 'property_unit_max_tenants')
                              }
                              // value={roomDetails[index]?.property_unit_max_tenants || ''}
                              // className={clsx('form-control bg-transparent')}
                            />
                          </div>

                          <div className='form-label fw-bolder text-dark fs-6'>
                            <label className='form-label fw-bolder text-dark fs-6'>
                              Expected Rent
                            </label>
                            <input
                              type='number'
                              autoComplete='off'
                              className='form-control bg-transparent'
                              value={roomDetails[index]?.property_unit_rent || ''}
                              onChange={(event) =>
                                handleRoomDetailChange(event, index, 'property_unit_rent')
                              }
                            />
                          </div>
                          {/* 

      <label className='form-label fw-bolder text-dark fs-6' style={{ marginRight: '10px' }}>
        Name:
      </label>

      <input
        className='form-control bg-transparent'
        style={{ width: '20%' ,height:'15%', marginRight: '10px' }}
        type='text'
        value={detail.unitName}
        onChange={(event) => handleRoomDetailChange(event, index, 'unitName')}
        required
      /> */}

                          {/* <label className='form-label fw-bolder text-dark fs-6' style={{ marginRight: '10px' }}>
        Description:
      </label>
      <textarea
        className='form-control bg-transparent'
        style={{ width: '20%', marginRight: '10px' }}
        value={detail.roomDesc}
        onChange={(event) => handleRoomDetailChange(event, index, 'roomDesc')}
        required
      /> */}

                          {/* <label className='form-label fw-bolder text-dark fs-6' style={{ marginRight: '10px' }}>
        No of tenants:
      </label>
      <input
        type='number'
        className='form-control bg-transparent'
        style={{ width: '20%',height:'15%' ,marginRight: '10px' }}
        value={detail.numTenants}
        onChange={(event) => handleRoomDetailChange(event, index, 'numTenants')}
        required
      /> */}

                          {/* <label className='form-label fw-bolder text-dark fs-6' style={{ marginRight: '10px' }}>
       Expected Rent:
      </label>
      <input
        type='number'
        className='form-control bg-transparent'
        style={{ width: '20%',height:'15%' ,marginRight: '10px'}}
        value={detail.expectedRent}
        onChange={(event) => handleRoomDetailChange(event, index, 'expectedRent')}
        required
      /> */}
                        </MDBCol>
                      </div>
                    </MDBRow>
                  ))}
                </>
              ) : (
                ''
              )}

              {comProperty ? (
                <>
                  <label className='form-label fw-bolder text-dark fs-6'>
                    Enter the number of rooms:
                  </label>
                  <input
                  type='text'
                    className='form-control bg-transparent'
                    style={{width: '10%', marginBottom: '10px'}}
                    //value={numRooms}
                    onChange={handleNumRoomsChange}
                  />

                  {roomDetails.map((detail, index) => (
                    <MDBRow>
                      <div key={index} style={{marginBottom: '20px'}}>
                        <h2 className='text-primary ' key={index}>
                          Room {index + 1}
                        </h2>
                        <MDBCol style={{display: 'flex', justifyContent: 'space-around'}}>
                          <div className='form-label fw-bolder text-dark fs-6'>
                            <label className='form-label fw-bolder text-dark fs-6'>
                              {' '}
                              Unit Name
                            </label>
                            <input
                            onKeyPress={handleKeyPress}
                              key={index}
                              type='text'
                              autoComplete='off'
                              value={roomDetails[index]?.property_unit_name || ''}
                              onChange={(event) =>
                                handleRoomDetailChange(event, index, 'property_unit_name')
                              }
                              className='form-control bg-transparent'
                              // {
                              //   'is-invalid': formik.touched.city && formik.errors.city,
                              // },
                              // {
                              //   'is-valid': formik.touched.city && !formik.errors.city,
                              // }
                            />
                            {/* {formik.touched.city && formik.errors.city && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.city}</span>
                    </div>
                  </div>
                )} */}
                          </div>

                          <div className='form-label fw-bolder text-dark fs-6'>
                            <label className='form-label fw-bolder text-dark fs-6'>
                              Unit Description
                            </label>
                            <textarea
                              autoComplete='off'
                              value={roomDetails[index]?.property_unit_description || ''}
                              onChange={(event) =>
                                handleRoomDetailChange(event, index, 'property_unit_description')
                              }
                              className={clsx('form-control bg-transparent')}
                            />
                          </div>

                          <div className='form-label fw-bolder text-dark fs-6'>
                            <label className='form-label fw-bolder text-dark fs-6'>
                              No of Tenants
                            </label>
                            <input
                              type='number'
                              onKeyPress={handleKeyPress}
                              autoComplete='off'
                              onChange={(event) =>
                                handleRoomDetailChange(event, index, 'property_unit_max_tenants')
                              }
                              //value={roomDetails[index]?.property_unit_max_tenants || ''}
                              className={clsx('form-control bg-transparent')}
                            />
                          </div>

                          <div className='form-label fw-bolder text-dark fs-6'>
                            <label className='form-label fw-bolder text-dark fs-6'>
                              Expected Rent
                            </label>
                            <input
                            onKeyPress={handleKeyPress}
                              type='number'
                              autoComplete='off'
                              onChange={(event) =>
                                handleRoomDetailChange(event, index, 'property_unit_rent')
                              }
                              value={roomDetails[index]?.property_unit_rent || ''}
                              className={clsx('form-control bg-transparent')}
                            />
                          </div>
                        </MDBCol>
                      </div>
                    </MDBRow>
                  ))}
                </>
              ) : (
                ''
              )}
</>
              ) : (
                ''
              )}

              {/* <MDBTextArea label='Additional information' rows={4} className="mb-4" /> */}
              <div className='text-center fv-row mb-8 '>
                <button
                  style={{padding: 10, marginRight: 10, marginTop: 7}}
                  type='submit'
                  id='kt_sign_in_submit'
                  className='btn btn-lg btn-primary  w-30  mb-3'
                  onClick={props.onBackButtonClick}
                >
                  <span>Back</span>
                </button>
                <button
                  style={{padding: 10, marginTop: 7}}
                  type='submit'
                  id='kt_sign_in_submit'
                  className='btn btn-lg btn-primary  w-30  mb-3'
                  disabled={formik.isSubmitting || !formik.isValid}
                >
                  {!loading && <span className='indicator-label'>Next</span>}
                  {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Please wait...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </form>
  )
}
export default Add_NewProperty
